import React from 'react';
import PropTypes from 'prop-types';
import { Visible } from '@tfecom-thermofisher/react-komodo-design';

import { Menu } from 'src/components';

import { Overview, DetailView, EmptyOverview } from './components';
import './MCPLayoutStyle.scss';

const MCPLayoutComponent = ({
  isViewAllActive,
  selectedMenuItem,
  setSelectedMenuItem,
  menuGroups,
  overviewData,
  staticMenuItems
}) => (
  <div className="mcp-content">
    <Menu
      selectedMenuItem={selectedMenuItem}
      onSelectMenuItem={setSelectedMenuItem}
      menuGroups={menuGroups}
      isViewAllActive={isViewAllActive}
    />
    <div className="mcp-content__right">
      <Visible when={!overviewData.length}>
        <EmptyOverview staticMenuItems={staticMenuItems} />
      </Visible>
      <Visible when={overviewData.length}>
        <Visible when={isViewAllActive}>
          <Overview
            {...{
              data: overviewData,
              setSelectedMenuItem,
              isViewAllActive
            }}
          />
        </Visible>
        <Visible when={!isViewAllActive}>
          <DetailView
            {...{
              category: selectedMenuItem.category,
              subcategory: selectedMenuItem.subcategory,
              isViewAllActive,
            }}
          />
        </Visible>
      </Visible>
    </div>
  </div>
);

MCPLayoutComponent.propTypes = {
  isViewAllActive: PropTypes.bool,
  selectedMenuItem: PropTypes.object,
  setSelectedMenuItem: PropTypes.func.isRequired,
  menuGroups: PropTypes.array.isRequired,
  overviewData: PropTypes.array.isRequired,
  staticMenuItems: PropTypes.array
};

export default MCPLayoutComponent;
